export const ScheduleStatusEnum = {
  PENDING: 1,
  CANCELLED: 2,
  PROCESSED: 3,
};
